import allPartner from './icons/partner/all-partner.svg'
import arrowDown from './icons/arrow-down.svg'
import arbitrum from './icons/chain/arbitrum.svg'
import base from './icons/chain/base.svg'
import bsc from './icons/chain/bsc.svg'
import ethereum from './icons/chain/ethereum.svg'
import betaTag from './icons/beta-tag.svg'
import bg from './icons/bg.svg'
import ehex from './icons/token/ehex.svg'
import eth from './icons/token/eth.svg'
import hex from './icons/token/hex.svg'
import icArrowSwap from './icons/ic-arrow-swap.svg'
import icArrowUpRight1 from './icons/ic-arrow-up-right-1.svg'
import icChevronDown from './icons/ic-chevron-down.svg'
import icClose from './icons/ic-close.svg'
import icFillInformation from './icons/ic-fill-information.svg'
import icGlobal from './icons/ic-global.svg'
import icHeartCum from './icons/ic-heart-cum.svg'
import icKey from './icons/ic-key.svg'
import icMagicpen from './icons/ic-magicpen.svg'
import icRailgunLog from './icons/railgun/ic-railgun-log.svg'
import icSecuritySafe from './icons/ic-security-safe.svg'
import icShieldTick from './icons/ic-shield-tick.svg'
import icSwapArrowUpDown from './icons/ic-swap-arrow-up-down.svg'
import icToggle from './icons/ic-toggle.svg'
import inc from './icons/token/inc.svg'
import liquidity from './icons/liquidity.svg'
import logo from './icons/logo.svg'
import pcock from './icons/token/pcock.svg'
import pcockBanner from './icons/pcok-dex/pcock-banner.png'
import pcockBannerWeb from './icons/pcok-dex/pcock-banner-web.png'
import pdai from './icons/token/pdai.svg'
import pls from './icons/token/pls.svg'
import plsx from './icons/token/plsx.svg'
import privateModeBanner from './icons/pcok-dex/private-mode-banner.png'
import privateModeBannerWeb from './icons/pcok-dex/private-mode-banner-web.png'
import prvx from './icons/token/prvx.svg'
import pulsechain from './icons/chain/pulsechain.svg'
import shieldGradientBg from './icons/shield/shield-gradient-bg.png'
import usdc from './icons/token/usdc.svg'
import x from './icons/x.svg'
import icArrowRight from './icons/ic-arrow-right.svg'
import exchangeBackdrop from './icons/exchange-backdrop.svg'
import exchangeGradientBg from './icons/shield/exchange-gradient-bg.png'
import icChevronLeft from './icons/ic-chevron-left.svg'
import horizontalDexBanner from './icons/horizontal-dex-banner.svg'
import pcockAvatar from './icons/pcock-avatar.png'
import iCFillCopy from './icons/ic-fill-copy.svg'
import icArrowUp from './icons/ic-arrow-up.svg'
import pdaiAvatar from './icons/pdai-avatar.png'
import icSwapLeftRight from './icons/ic-swap-arrow-left-right.svg'
import metamask from './icons/metamask.svg'

export const LIBERTY_IMAGES = {
    ALL_PARTNER: allPartner,
    ARROW_DOWN: arrowDown,
    ARBITRUM: arbitrum,
    EXCHANGE_BACKDROP: exchangeBackdrop,
    EXCHANGE_GRADIENT_BG: exchangeGradientBg,
    HORIZONTAL_DEX_BANNER: horizontalDexBanner,
    IC_SWAP_ARROW_LEFT_RIGHT: icSwapLeftRight,
    PCOCK_AVATAR: pcockAvatar,
    IC_FILL_COPY: iCFillCopy,
    IC_ARROW_UP: icArrowUp,
    PDAI_AVATAR: pdaiAvatar,
    BASE: base,
    BSC: bsc,
    BETA_TAG: betaTag,
    BG: bg,
    EHEX: ehex,
    ETH: eth,
    ETHEREUM: ethereum,
    HEX: hex,
    IC_ARROW_SWAP: icArrowSwap,
    IC_ARROW_UP_RIGHT_1: icArrowUpRight1,
    IC_ARROW_RIGHT: icArrowRight,
    IC_CHEVRON_DOWN: icChevronDown,
    IC_CHEVRON_LEFT: icChevronLeft,
    IC_CLOSE: icClose,
    IC_FILL_INFORMATION: icFillInformation,
    IC_GLOBAL: icGlobal,
    IC_HEART_CUM: icHeartCum,
    IC_KEY: icKey,
    IC_MAGICPEN: icMagicpen,
    IC_RAILGUN_LOG: icRailgunLog,
    IC_SECURITY_SAFE: icSecuritySafe,
    IC_SHIELD_TICK: icShieldTick,
    IC_SWAP_ARROW_UP_DOWN: icSwapArrowUpDown,
    IC_TOGGLE: icToggle,
    INC: inc,
    LIQUIDITY: liquidity,
    LOGO: logo,
    PCOCK: pcock,
    PCOCK_BANNER: pcockBanner,
    PCOCK_BANNER_WEB: pcockBannerWeb,
    PDAI: pdai,
    PLS: pls,
    PLSX: plsx,
    PRIVATE_MODE_BANNER: privateModeBanner,
    PRIVATE_MODE_BANNER_WEB: privateModeBannerWeb,
    PRVX: prvx,
    PULSECHAIN: pulsechain,
    SHIELD_GRADIENT_BG: shieldGradientBg,
    USDC: usdc,
    X: x,
    METAMASK: metamask
}
